/* eslint-disable @typescript-eslint/unbound-method */
import { initStream } from "../init-stream.js";
export function string(initialValue) {
    let value = initialValue;
    const events = initStream();
    const set = (v) => {
        value = v;
        events.set(v);
    };
    return {
        dispose: events.dispose,
        isDisposed: events.isDisposed,
        last: () => value,
        on: events.on,
        onValue: events.onValue,
        set
    };
}
